<template>
  <div :class="adaptiveClass" v-if="agent">
    <div class="card-consult">
      <div class="card-consult__image">
        <img :src="agentPhoto" alt="alt" />
      </div>
      <div class="card-consult__title" v-html="agentName" />
      <div :class="phoneClass" v-if="agentPhone">
        <a :href="`tel:${agentPhone}`" class="phone-block__number" v-text="agentPhone" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PersonalAgent',
  props: {
    type: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters(['agent', 'agentPhoto', 'isPrint']),
    adaptiveClass() {
      return {
        'mob-card-wr': this.type === 'mobile',
        'card-right': this.type === 'desktop',
        'desktop-margin': this.type === 'desktop',
        'print-height': this.isPrint,
      }
    },
    phoneClass() {
      return {
        'phone-block': !this.isPrint,
        active: !this.isPrint,
      }
    },
    agentName() {
      const { name: agentName } = this.agent
      return agentName && agentName
        .split(' ')
        .map((p, idx) => idx === 0 ? `${p} <br />` : p)
        .join(' ')
    },
    agentPhone() {
      return this.agent.phone_number
    },
  },
}
</script>

<style scoped>
.desktop-margin {
  margin-top: 111px;
}
@media print {
  .card-consult {
    margin-top: 0 !important;
    min-height: 0 !important;
  }
  .card-consult__image {
    width: 9vw !important;
    height: 9vw !important;
  }
  .phone-block__number::before {
    background: transparent !important;
  }
  .print-height {
    height: 20vh !important;
  }
}
</style>